/**
 * Message d'un refus du serveur, tel qu'il doit s'afficher.
 *
 * Les services NestJS répondent sous trois formes :
 *  - validation : { message: ['champ doit ...', ...], error: 'Bad Request' } ;
 *  - refus métier : { message: 'Le nom est déjà pris' } ;
 *  - refus enveloppé : { message: 'Erreur lors de ...', error: '<raison>' }.
 * Seul `message` était lu : une liste arrivait brute, et la raison d'un refus
 * enveloppé (dans `error`) disparaissait derrière un libellé générique.
 */
const HTTP_STATUS_PHRASES = new Set([
  'bad request',
  'unauthorized',
  'forbidden',
  'not found',
  'conflict',
  'unprocessable entity',
  'internal server error',
  'too many requests',
]);

export function serverErrorMessage(body: unknown, fallback: string): string {
  const b = body !== null && typeof body === 'object' ? (body as { message?: unknown; error?: unknown }) : {};
  const raw = b.message;
  const parts = (Array.isArray(raw) ? raw : [raw])
    .filter((m): m is string | number => (typeof m === 'string' && m.trim() !== '') || typeof m === 'number')
    .map((m) => String(m).trim());
  let message = parts.length > 1 ? 'Données invalides :\n• ' + parts.join('\n• ') : parts[0] ?? '';
  const detail = typeof b.error === 'string' ? b.error.trim() : '';
  if (detail && !HTTP_STATUS_PHRASES.has(detail.toLowerCase()) && !message.includes(detail)) {
    message = message ? `${message} : ${detail}` : detail;
  }
  return message || fallback;
}
